import { render, staticRenderFns } from "./carddetail.vue?vue&type=template&id=1daa5e8c&scoped=true"
import script from "./carddetail.vue?vue&type=script&lang=js"
export * from "./carddetail.vue?vue&type=script&lang=js"
import style0 from "./carddetail.vue?vue&type=style&index=0&id=1daa5e8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daa5e8c",
  null
  
)

export default component.exports